import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cursor: true,
  radar: true,
  lineOwn: true,
  popUpBox: true,
  deletionAnimation: true,
  deletionObj: null,
};

export const featuresSlice = createSlice({
  name: 'featuresMag',
  initialState,
  reducers: {
    updateFeatures: (state, action) => {
      // console.log(action.payload);
      state[action.payload.type] = action.payload.state;
    },
  },
});

export const { updateFeatures } = featuresSlice.actions;

export const cursorFeature = (state) => state.featuresMag.cursor;
export const radarFeature = (state) => state.featuresMag.radar;
export const lineOwnFeature = (state) => state.featuresMag.lineOwn;
export const popUpBoxFeature = (state) => state.featuresMag.popUpBox;
export const deletionAnimationFeature = (state) =>
  state.featuresMag.deletionAnimation;
export const deletionObj = (state) => state.featuresMag.deletionObj;

export default featuresSlice.reducer;
